import React, { useEffect, useState } from "react";
import axios from "axios";
import PatchImage from '../image/PatchImage'
import PostImage from "../image/PostImage";
import OptionImage from "../image/OptionImage";
const useBaseAdminModal = ({
    type = "post"
}) => {
    const [modalStyle, setModalStyle] = useState({
        borderTop: "#d65a77",
        backgroundColor: "#faf6f5"
    })
    const [cancelButtonStyle, setCancelButtonStyle] = useState({
        backgroundColor: "#4a4a4a",
        color: "#000"
    })
    const [okButtonStyle, setOkButtonStyle] = useState({
        backgroundColor: "#e84f75",
        color: "#000"
    })
    const getImageSrc = (type) => {
        let src = PostImage
        if (type === "post") {
            src = PostImage
        }
        else if (type === "patch") {
            src = PatchImage
        }
        else {
            src = OptionImage
        }
        return src
    }
    useEffect(() => {
        if (type === "post") {
            setModalStyle({
                borderTop: "#d65a77",
                backgroundColor: "#faf6f5"
            })
            setCancelButtonStyle({
                backgroundColor: "#4a4a4a",
                color: "#fff"
            })
            setOkButtonStyle({
                backgroundColor: "#e84f75",
                color: "#fff"
            })
        }
        else if (type === "patch") {
            setModalStyle({
                borderTop: "#f09a45",
                backgroundColor: "#f9f6f5"
            })
            setCancelButtonStyle({
                backgroundColor: "#4a4a4a",
                color: "#fff"
            })
            setOkButtonStyle({
                backgroundColor: "#f09a45",
                color: "#fff"
            })
        }
        else {
            setModalStyle({
                borderTop: "#7991d4",
                backgroundColor: "#f4fcf9"
            })
            setCancelButtonStyle({
                backgroundColor: "#4a4a4a",
                color: "#fff"
            })
            setOkButtonStyle({
                backgroundColor: "#7991d4",
                color: "#fff"
            })
        }
    }, [type])
    return {
        imageSrc: getImageSrc(type),
        ModalBorderTop: modalStyle?.borderTop,
        ModalBackgroundColor: modalStyle?.backgroundColor,
        cancelButtonBackgroundColor:cancelButtonStyle?.backgroundColor,
        cancelButtonColor:cancelButtonStyle?.color,
        okButtonBackgroundColor:okButtonStyle?.backgroundColor,
        okButtonColor:okButtonStyle?.color,
    }
}
export { useBaseAdminModal }
